﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApplicationsActionTypes;
(function (ApplicationsActionTypes) {
    ApplicationsActionTypes["ADD_APPLICATION_LIST"] = "ADD_APPLICATION_LIST";
})(ApplicationsActionTypes = exports.ApplicationsActionTypes || (exports.ApplicationsActionTypes = {}));
exports.actionCreators = {
    setApplicationList: (appList) => ({
        type: ApplicationsActionTypes.ADD_APPLICATION_LIST,
        payload: appList
    })
};
//# sourceMappingURL=actions.js.map